import { render, staticRenderFns } from "./OrgPaymentProviderConfig.vue?vue&type=template&id=8fcafa64&"
import script from "./OrgPaymentProviderConfig.vue?vue&type=script&lang=js&"
export * from "./OrgPaymentProviderConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports